import Typography from '@mui/material/Typography';
import { useGoalCompletion, useUpdateGoal } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LifeAreaRocket } from 'shared/assets/icons';
import { Alert, Colors as AlertColors } from 'shared/components/ui/alert';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { useCompleteGoal } from 'shared/contexts/complete-goal';
import { Goal } from 'shared/types/goal';

import * as Styled from './completion-banner.style';

export type CompletionBannerProps = {
  goal: Goal;
};

export const CompletionBanner: React.FC<CompletionBannerProps> = ({ goal }) => {
  const { t } = useTranslation();
  const goalProgress = useGoalCompletion(goal.id);
  const completeGoal = useCompleteGoal();
  const { submit } = useUpdateGoal();

  const onComplete = () => !!goal && completeGoal(goal);

  const onCloseAlert = () => {
    if (!goal) {
      return;
    }

    submit({
      id: goal.id,
      metadata: { ...(goal.metadata ?? {}), hideCompletionBanner: true },
    });
  };

  if (
    !(
      goalProgress.completed >= goalProgress.end &&
      !goal?.completedAt &&
      !goal?.metadata?.hideCompletionBanner
    )
  ) {
    return null;
  }

  return (
    <Styled.CompletionBanner>
      <Alert
        startIcon={LifeAreaRocket}
        color={AlertColors.Success}
        onClose={onCloseAlert}
        action={
          <Button
            variant={Variants.Contained}
            color={Colors.Success}
            size={Sizes.Small}
            onClick={onComplete}
          >
            {t('pages.goal-detail.progress.complete-goal.button')}
          </Button>
        }
      >
        <Typography variant="overline" component="span">
          {t('pages.goal-detail.progress.complete-goal.description')}
        </Typography>
      </Alert>
    </Styled.CompletionBanner>
  );
};
